module.exports = __webpack_public_path__ + "static/img/why-6.e3269b11.png";